<script>

import moment from 'moment';
export default {

    components: {

    },

    props: {

    },

    data (){
        return {
            feeds: [],
            broadcastRights: [],
            configurations: [],
        };
    },

    computed: {
        toLoad (){
            return [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        status__in: 'AVAILABLE,PENDING,RUNNING,STARTING,PREPARING',
                        ordering: 'start_date',
                        archived: false,
                    }
                },
                {
                    name: 'broadcastRights',
                    model: 'broadcastRights',
                    filters: {
                        revoked: false,
                        archived: false,
                    }
                },
                {
                    name: 'configurations',
                    model: 'configurations',
                    filters: {
                        status__in: 'PENDING,WAIT_UNTIL_COMPLETION,STOP_CURRENT',
                        start_date__range: this.rangeNext30Days,
                        cancelled: false,
                        archived: false,
                    }
                }
            ];
        },
        rangeNext30Days (){
            let now = moment.utc().format();
            let later = moment.utc().add(30, 'days').format();
            return `${now},${later}`;
        },

        next30Days (){
            return moment.utc().add(30, 'days');
        },

        feedsWithRight (){
            return this.feeds.filter((feed) => {
                return this.broadcastRights.find((br) => {
                    if(this.$store.getters.currentTaker){
                        return br.feed_uid === feed.uid && br.taker_uid === this.$store.getters.currentTaker.uid;
                    }
                    return br.feed_uid === feed.uid;
                });
            }).sort((a, b) => {
                return new Date(a.confirmed ? a.confirmed_start_date : a.start_date) -
                new Date(b.confirmed ? b.confirmed_start_date : b.start_date);
            });
        },

        nextFeedStartDate (){
            return this.$store.getters.nextFeedStartDate(this.feedsWithRight);
        },

        runningFeeds (){
            return this.feedsWithRight.filter((feed) => {
                return feed.status === 'RUNNING';
            }).length;
        },

        scheduledFeeds (){
            return this.feedsWithRight.filter((feed) => {
                if(!['AVAILABLE', 'PREPARING', 'STARTING'].includes(feed.status)){
                    return false;
                }
                let startDate = moment.utc(feed.confirmed ? feed.confirmed_start_date : feed.start_date);
                return startDate.isBefore(this.next30Days) && startDate.isAfter(moment.utc().format());
            }).length;
        },
        availableConfigurations (){
            return this.configurations.filter((conf) => {
                return this.feedsWithRight.find((feed) => {
                    return conf.feed_uid === feed.uid;
                });
            }).length;
        }
    },

    mounted (){

    },

    methods: {
        onDataFetched (res){
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'configurations', res.configurations);
            this.$set(this, 'broadcastRights', res.broadcastRights);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/global-view-info-mixin.vue